import request from '@/utils/request'

export function fetchDataDictList(params) {
  return request({
    url:'/data-dict/list',
    method:'get',
    params:params
  })
}



// WEBPACK FOOTER //
// ./src/api/data-dict.js